
import { useState } from 'react';

interface LanguageToggleProps {
  currentLang: 'es' | 'en';
  onLanguageChange: (lang: 'es' | 'en') => void;
}

export default function LanguageToggle({ currentLang, onLanguageChange }: LanguageToggleProps) {
  return (
    <div className="flex items-center bg-white/10 backdrop-blur-sm rounded-full p-1">
      <button
        onClick={() => onLanguageChange('es')}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
          currentLang === 'es'
            ? 'bg-white text-red-600 shadow-sm'
            : 'text-white hover:bg-white/20'
        }`}
      >
        🇪🇸 ES
      </button>
      <button
        onClick={() => onLanguageChange('en')}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
          currentLang === 'en'
            ? 'bg-white text-red-600 shadow-sm'
            : 'text-white hover:bg-white/20'
        }`}
      >
        🇺🇸 EN
      </button>
    </div>
  );
}
